export default __webpack_public_path__ + "static/media/constructor.f7f19544.png";